import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
declare var jQuery: any;
import "../../../../assets/semantic/semantic.min.js";
import { CityService } from "../../../_services/city.service";
import { AreaService } from "../../../_services/area.service";


@Component({
  selector: "app-edit-city",
  templateUrl: "./edit-city.component.html",
  styleUrls: ["./edit-city.component.css"],
})
export class EditCityComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private updating_city = false;
  private city_id: number;
  private edit_areas: object[];
  private edit_cities: object[]; 

  constructor(private cityService: CityService, private areaService: AreaService) {}

  edit_city = new FormGroup({
    name: new FormControl("", [Validators.required]),
    area_id: new FormControl(),
    new_city_id: new FormControl(),
    archived: new FormControl(),
  });

  ngOnInit() {
    let area_params = {full: true};
    this.areaService.getAreas(area_params).subscribe((response) => {
      this.edit_areas = response.areas;
    });

    let city_params = {full: true};
    this.cityService.getCities(city_params).subscribe((response) => {
      this.edit_cities = response.cities;
    });
  }

  openModal(city) {
    this.city_id = city.id; // Set the Contact_id needed in the Update Contact URL
    this.edit_city.patchValue({
      // Fill the FormGroup
      name: city.name,
      area_id: city.area_id,
      archived: city.archived,
    });

     

    jQuery("#edit-city-modal").modal({ inverted: true }).modal("show"); // Show the Modal
  }

  // Update Company
  submitCityForm() {
    this.edit_city.disable(); // Disable the form to avoid changes during the Updating process
    this.updating_city = true; // Trigger the Loading button apparition
    jQuery("#edit-city-modal").modal({ closable: false }); // Set the modal unclosable during the Updating process
    // Create the Contact
    this.cityService.updateCity(this.city_id, this.edit_city.value).subscribe((response) => {
        jQuery("#edit-city-modal").modal({ closable: true }).modal("hide"); // Set the modal closable & Close the modal
        this.updating_city = false; // Disable the loading button apparition
        this.edit_city.enable(); // Re Enable the Form
        this.edit_city.reset(); // Reset It
        this.refresh.emit(true); // Emmit the refresh Event
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/city/edit-city/edit-city.component.ts